import { GET_ORDER_CONTACT_INFO } from '../actionTypes/OrderActionTypes';

export const getOrderContactInfo = (payload) => ({
    type: GET_ORDER_CONTACT_INFO,
    payload,
});

export default getOrderContactInfo;
